import React from "react";
import { Card, Flex } from "rebass";

import { SpinnerSVG } from "../svg/SpinnerSVG";
import { LogoSVG } from "../svg/LogoSVG";

export const LogoSpinner: React.FC = () => (
  <Flex
    height="100%"
    justifyContent="center"
    alignItems="center"
    color="sp-blue"
    css="position: relative;"
  >
    <SpinnerSVG size={80} />

    <Card
      bg="sp-blue"
      p="5px"
      borderRadius="50%"
      css="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    >
      <LogoSVG size={40} />
    </Card>
  </Flex>
);
